import PATH from "../config/PATH";
import moment from "moment";
import { getData } from "../utils/localstorage";
import { useEffect, useState } from "react";

export { currentDate, TYPE_LOGIN };

const currentDate = new Date().getTime();

export const IS_SHOW_EVENT_2024 = 0;

/* Canvas design chuẩn của web-v3 (Figma) và bề rộng cột nội dung
   (.main-layout-website trong src/assets/styles/web-v3-styles/index.scss).
   Dùng để tính tỉ lệ thu nhỏ TOÀN APP ở src/layout/LayoutApp.jsx: tỉ lệ đó chỉ
   được phép phụ thuộc viewport + canvas chuẩn, không phụ thuộc chiều cao nội
   dung của route đang mở, nếu không các màn sẽ hiển thị to nhỏ khác nhau. */
export const DESIGN_CANVAS = {
  WIDTH: 880,
  HEIGHT: 1904,
  COLUMN_WIDTH: 768,
};

/* Nới tỉ lệ thu nhỏ toàn app thêm 15% so với mức "vừa khít chiều cao cửa sổ":
   khít đúng 100% thì app trông quá bé trên desktop. Đánh đổi: canvas chuẩn cao
   hơn cửa sổ đúng 15% -> phải cuộn một đoạn ngắn. Đây là NÚM ĐIỀU CHỈNH duy nhất
   cho cỡ app, tăng/giảm ở đây thay vì sửa công thức trong LayoutApp.
   1 = khít cửa sổ, không cuộn. 1.15 = to hơn 15%, cuộn ~15% chiều cao cửa sổ. */
export const APP_SCALE_BOOST = 1.15;
const THADINGYU_THEME_END = moment("2025-10-31 23:59:59");
const NEW_YEAR_2025_THEME_END = moment("2025-12-31 23:59:59");
const BIRTHDAY_2026_THEME_END = moment("2026-06-30 23:59:59");

const checkIsThadingyut2025Ended = () => {
  const now = moment();
  const endDate = moment(THADINGYU_THEME_END);
  // console.log(now.isBefore(endDate));

  return now.isBefore(endDate);
};

// check new year 2025 ended
const checkIsNewYear2025Ended = () => {
  const now = moment();
  const endDate = moment(NEW_YEAR_2025_THEME_END);
  return now.isBefore(endDate);
};

// Check birthday 2026 ended
const checkIsBirthday2026Ended = () => {
  const now = moment();
  const endDate = moment(BIRTHDAY_2026_THEME_END);
  return now.isBefore(endDate);
};

// hook check event new year 2025
export const useNewYear2025Theme = () => {
  const [isTheme, setIsTheme] = useState(() => checkIsNewYear2025Ended());

  useEffect(() => {
    const endDate = moment(NEW_YEAR_2025_THEME_END);
    
    const updateThemeState = () => {
      const now = moment();
      const isActive = now.isBefore(endDate);
      setIsTheme(isActive);
      return isActive;
    };
    
    // Check luôn
    const currentState = updateThemeState();
    
    // nếu hết event thì khỏi chạy timer
    if (!currentState) {
      return;
    }
    
    const now = moment();
    const msUntilEnd = endDate.diff(now);
    
    // nếu end time trong khoảng 2 phút tới, set timeout 
    if (msUntilEnd > 0 && msUntilEnd <= 120000) {
      const timeout = setTimeout(() => {
        setIsTheme(false);
      }, msUntilEnd);
      
      return () => clearTimeout(timeout);
    }
    
    // If end time is further away, use interval with smart frequency
    if (msUntilEnd > 0) {
      // Check more frequently as we get closer to end time
      const checkInterval = msUntilEnd > 3600000 ? 300000 : 30000; // 5min if >1hr away, 30sec otherwise
      
      const interval = setInterval(() => {
        const stillActive = updateThemeState();
        
        // Clear interval once event ends
        if (!stillActive) {
          clearInterval(interval);
        }
      }, checkInterval);

      return () => clearInterval(interval);
    }
  }, []);

  return isTheme;
}

export const useBirthdayTheme = () => {
  const [isTheme, setIsTheme] = useState(() => checkIsBirthday2026Ended());

  useEffect(() => {
    const endDate = moment(BIRTHDAY_2026_THEME_END);
    
    const updateThemeState = () => {
      const now = moment();
      const isActive = now.isBefore(endDate);
      setIsTheme(isActive);
      return isActive;
    };
    
    // Check luôn
    const currentState = updateThemeState();
    
    // nếu hết event thì khỏi chạy timer
    if (!currentState) {
      return;
    }
    
    const now = moment();
    const msUntilEnd = endDate.diff(now);
    
    // nếu end time trong khoảng 2 phút tới, set timeout 
    if (msUntilEnd > 0 && msUntilEnd <= 120000) {
      const timeout = setTimeout(() => {
        setIsTheme(false);
      }, msUntilEnd);
      
      return () => clearTimeout(timeout);
    }
    
    // If end time is further away, use interval with smart frequency
    if (msUntilEnd > 0) {
      // Check more frequently as we get closer to end time
      const checkInterval = msUntilEnd > 3600000 ? 300000 : 30000; // 5min if >1hr away, 30sec otherwise
      
      const interval = setInterval(() => {
        const stillActive = updateThemeState();
        
        // Clear interval once event ends
        if (!stillActive) {
          clearInterval(interval);
        }
      }, checkInterval);

      return () => clearInterval(interval);
    }
  }, []);

  return isTheme;
}

// Optimized hook with smart timing
export const useThadingyutTheme = () => {
  const [isTheme, setIsTheme] = useState(() => checkIsThadingyut2025Ended());

  useEffect(() => {
    const endDate = moment(THADINGYU_THEME_END);
    
    const updateThemeState = () => {
      const now = moment();
      const isActive = now.isBefore(endDate);
      setIsTheme(isActive);
      return isActive;
    };
    
    // Check luôn
    const currentState = updateThemeState();
    
    // nếu hết event thì khỏi chạy timer
    if (!currentState) {
      return;
    }
    
    const now = moment();
    const msUntilEnd = endDate.diff(now);
    
    // nếu end time trong khoảng 2 phút tới, set timeout
    if (msUntilEnd > 0 && msUntilEnd <= 120000) {
      const timeout = setTimeout(() => {
        setIsTheme(false);
      }, msUntilEnd);
      
      return () => clearTimeout(timeout);
    }
    
    // If end time is further away, use interval with smart frequency
    if (msUntilEnd > 0) {
      // Check more frequently as we get closer to end time
      const checkInterval = msUntilEnd > 3600000 ? 300000 : 30000; // 5min if >1hr away, 30sec otherwise
      
      const interval = setInterval(() => {
        const stillActive = updateThemeState();
        
        // Clear interval once event ends
        if (!stillActive) {
          clearInterval(interval);
        }
      }, checkInterval);

      return () => clearInterval(interval);
    }
  }, []);

  return isTheme;
};

export const realtime_type = {
  start: 0,
  real: 1,
  end: 2,
};

const TYPE_LOGIN = {
  default: 0,
  loginPassword: 1,
  loginOtp: 2,
};

export const urlPageBid = {
  running: "running",
  upcoming: "upcoming",
  purchasing: "purchasing",
};

export const urlPageResult = {
  all: "previous-winners",
  the_winner: "my-win",
  no_winner: "no-winer",
};

export const ID_EVENT = {
  lantern_collection: "lantern-collection",
  lucky_moon: "lucky-moon",
  rank_table: "rank-table",
  instruction: "instruction",
  congratulations: "congratulations",
};

export const TAB_EVENT = [
  {
    title: "မီးပုံးစုဆောင်းခြင်း။",
    id: ID_EVENT.lantern_collection,
  },
  {
    title: "lucky moon",
    id: ID_EVENT.lucky_moon,
  },
  {
    title: "အဆင့် ဇယား",
    id: ID_EVENT.rank_table,
  },
  {
    title: "ညွှန်ကြားချက်",
    id: ID_EVENT.instruction,
  },
];

export const TAB_EVENT_FINISHED = [
  {
    title: "အဆင့် ဇယား",
    id: ID_EVENT.rank_table,
  },
  {
    title: "ဂုဏ်ယူပါတယ်။",
    id: ID_EVENT.congratulations,
  },
  {
    title: "ညွှန်ကြားချက်",
    id: ID_EVENT.instruction,
  },
];

export const ID_TAB_EVENT_NEW_YEAR = {
  gameFireworks: "new-year-event",
  christmasTree: "christmas-tree",
  specialCode: "special-code",
  rankTable: "rank-table",
  instruction: "instruction",
  congratulation: "congratulation",
};

export const TAB_EVENT_NEW_YEAR = [
  {
    title: "New Year Event",
    id: ID_TAB_EVENT_NEW_YEAR.gameFireworks,
  },
  {
    title: "Christmas Tree",
    id: ID_TAB_EVENT_NEW_YEAR.christmasTree,
  },
  {
    title: "Special Code",
    id: ID_TAB_EVENT_NEW_YEAR.specialCode,
  },
  {
    title: "အဆင့် ဇယား",
    id: ID_TAB_EVENT_NEW_YEAR.rankTable,
  },
  {
    title: "ညွှန်ကြားချက်",
    id: ID_TAB_EVENT_NEW_YEAR.instruction,
  },
  // {
  //   title: "Congratulation",
  //   id: ID_TAB_EVENT_NEW_YEAR.congratulation,
  // },
];

export const TAB_EVENT_FINISHED_NEW_YEAR = [
  {
    title: "အဆင့် ဇယား",
    id: ID_TAB_EVENT_NEW_YEAR.rankTable,
  },
  {
    title: "ဂုဏ်ယူပါတယ်။။",
    id: ID_TAB_EVENT_NEW_YEAR.congratulation,
  },
  {
    title: "ညွှန်ကြားချက်",
    id: ID_TAB_EVENT_NEW_YEAR.instruction,
  },
];

export const urlPageHiddenEvents = [
  `${PATH.EVENT}/${ID_EVENT.lucky_moon}`,
  `${PATH.EVENT}/${ID_EVENT.lantern_collection}`,
  `${PATH.EVENT}/${ID_EVENT.instruction}`,
  `${PATH.EVENT}/${ID_EVENT.rank_table}`,
  `${PATH.EVENT}/${ID_EVENT.congratulations}`,
];

export const totalTableRankLimit = 10;

export const STATUS_ACTIVE_EVENT_LUCKY_MOON = 1;

export const ID_RANK = {
  myRank: 1,
  user: 0,
};

export const PYPE_ACTIVE_EVENT_NEW_YEAR_2024 = 1;

// event thingyan 2025
export const ID_TAB_EVENT_THINGYAN_2025 = {
  home: "home",
  collectPiece: "collect-piece",
  prizeCollection: "prize-collection",
  takePrize: "take-prize",
  pieceCollection: "piece-collection",
};

export const ID_TAB_MINI_GAME = {
  home: "home",
  collectPiece: "collect-piece",
  prizeCollection: "prize-collection",
  takePrize: "take-prize",
  pieceCollection: "piece-collection",
  buyMoreCoin: "buy-more-coin",
};

export const TAB_EVENT_THINGYAN_2025 = [
  {
    title: "Home",
    id: ID_TAB_EVENT_THINGYAN_2025.home,
  },
  {
    title: "Collect Piece",
    id: ID_TAB_EVENT_THINGYAN_2025.collectPiece,
  },
  {
    title: "Prize Collection",
    id: ID_TAB_EVENT_THINGYAN_2025.prizeCollection,
  },
  {
    title: "Take Prize",
    id: ID_TAB_EVENT_THINGYAN_2025.takePrize,
  },
  {
    title: "Piece Collection",
    id: ID_TAB_EVENT_THINGYAN_2025.pieceCollection,
  },
];

export const ID_TAB_TAKE_PRIZE = {
  takePrize: 1,
  pieceCollection: 2,
};

export const POPUP_TYPE_EVENT_THINGYAN_2025 = {
  congrats: "congrats",
  invite: "invite",
  error: "error",
  common: "common",
};

export const POPUP_VARIANT_EVENT_THINGYAN_2025 = {
  congratsPiece: "piece",
  congratsBid: "bid",
  congratsCoin: "coin",
  congratsChangeBid: "change-bid",
  congratsCoinSuper: "coin-super",
  congratsPuzzle: "puzzle",
  surfacePiece: "surface-piece",
  surfaceComplete: "surface-complete",
  goodLuck: "good-luck",
  noBids: "no-bids",
  noAttempts: "no-attempts",
  earnMore: "earn-more",
  winner: "winner",
  winnerFinish: "winner-finish",
  activityHistory: "history",
  rule: "rule",
};

export const MISSION_CARD_TYPE = {
  primary: "primary",
  secondary: "secondary",
  earn: "earn",
  change: "change",
  earnChange: "earn-change",
  earnChangeAll: "earn-change-all",
};

export const ID_GIFT_PLAY_LOTO = {
  good_luck: 1,
  bid_free: 2,
  puzzle_piece: 3,
  add_spin: 4,
};

export const ID_GIFT_PLAY_LOTO_MINIGAME = {
  ...ID_GIFT_PLAY_LOTO,
  coin_super: 5,
  no_coins: 6,
  mission_earn_coins: 7,
};

export const TYPE_MISSION_MINIGAME = {
  claimed: 1,
  execute: 2,
};

export const TYPE_GIVE_PIECE = {
  give: 1,
  shareLink: 2,
  linkExpired: 3,
  accept: 4,
  inviteUser: 7,
  linkExpiredInviteUser: 8,
  confirmInviteUser: 9,
};

export const TYPE_REQUEST_PIECE = {
  ...TYPE_GIVE_PIECE,
  requestLink: 5,
  requestConfirm: 6,
};

export const TYPE_GIVE_PIECE_SUCCESS = {
  receive: 1,
  give: 2,
  user_run_out: 3,
  no_more_turns: 4,
  referral_linked: 5,
  referral_successful: 6,
  receivePiece: 10,
  requestPiece: 11,
};

export const ID_INVITE_USER = 3;

export const TYPE_GIVE_MINIGAME = {
  request: 2,
  give: 1,
};

export const TYPE_DETAIL_PUZZLE_PIECE = "detail-puzzle_piece";

export const ID_STATE_INTRO_TOUR = {
  newUser: "new-user",
};
export const ID_HIDDEN_POPUP_INTRO = "hiddenPopupIntroMiniGame";
export const ID_HIDDEN_POPUP_INTRO_GIFT = "hiddenPopupIntroGiftMiniGame";

const handleCheckTime = (checkDay = "2025-09-11 00:00:00") => {
  const now = moment();
  const compareDate = moment(checkDay, "YYYY-MM-DD HH:mm:ss");

  if (!getData("check_day")) {
    return false;
  }

  if (now.isAfter(compareDate)) {
    return false; //Thời gian hiện tại lớn hơn 0h ngày 11/09/2025
  } else {
    return true; // Thời gian hiện tại nhỏ hơn 0h ngày 11/09/2025
  }
};
export const HIDDEN_POPUP_RANKING_MINIGAME = handleCheckTime(
  "2025-09-11 00:00:00"
);

export const INVITE_MARQUEE_START_DATE = moment("2026-01-01 00:00:00");
export const INVITE_MARQUEE_END_DATE = moment("2026-01-07 23:59:59");

export const TYPE_USER = {
  general: 0,
  newNoPackage: 1,
  newDeeplink: 2,
  newPackage: 3,
  firstLoginAfterRegistered7Days: 4,
  firstLoginWithinRegistered2To6Days: 5,
  loginButNeverBid: 6,
};

export const ERROR_CODE_TIMOUT = 417;

export const KEY_LOCAL_TYPE_USER = "typeUser";

export const KEY_LOCAL_TOUR_COMPLETE = "tourComplete";

export const CONFIG_SHWE_HOURS = {
  startShowIcon: 18,
  endShowIcon: 22,
  startBidTime: 19,
  endBidTime: 21,
  THIRTY_MINUTES: 30 * 60 * 1000,
  THIRTY_SECONDS: 30 * 1000,
}

export const DEVICE = "DEVICE";

export const IS_UPDATE_VERSION_3_PROJECT = true; // tùy chỉnh giao diện true là mới
export const IS_UPDATE_VERSION_3_PROJECT_LOGIN = true;